module.exports = "/_next/static/images/3c888b2109400c005f559dd671a73e8a-rewards-home-card@1x.png";